import { type Result, err, ok } from 'neverthrow';
import { ParserError } from './error';
import type { RuntimeFn } from './types/runtime';
import type { FnDescriptor } from './types/special';

const withSource = (fn: RuntimeFn, source: string): RuntimeFn => {
  Object.defineProperty(fn, 'toString', {
    configurable: true,
    value: () => source,
  });

  return fn;
};

export const serializeFn = <TArgs extends unknown[], TResult>(
  fn: (...args: TArgs) => TResult,
): FnDescriptor => {
  return {
    body: fn.toString().trim(),
  };
};

export const deserializeFn = (
  descriptor: FnDescriptor,
): Result<RuntimeFn, ParserError> => {
  let deserialized: unknown;

  try {
    deserialized = Function(`"use strict"; return (${descriptor.body});`)();
  } catch {
    return err(ParserError.FunctionDeserializationError);
  }

  if (typeof deserialized !== 'function') {
    return err(ParserError.FunctionDeserializationError);
  }

  return ok(withSource(deserialized as RuntimeFn, descriptor.body));
};
